import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Dashboard from '../views/Dashboard.vue'
import Login from '../views/Login.vue'
import Details from '../views/Details.vue'
import Banana from '../views/Detailspage/Banana.vue'
import Everything from '../views/Detailspage/Everything.vue'
import Glazed from '../views/Detailspage/Glazed.vue'
import Marshmallow from '../views/Detailspage/Marshmallow.vue'
import Plain from '../views/Detailspage/Plain.vue'
import Raisin from '../views/Detailspage/Raisin.vue'
import Create from '../views/Create.vue'
import Cart from '../views/Cart.vue'
import AdminLogin from '../views/AdminLogin.vue'
import Rewards from '../views/Rewards.vue'
import Terminalpos from '../views/Terminalpos.vue'
import Device from '../views/Device.vue'

import store from '../store/index'
Vue.use(VueRouter)
console.log(store.state.admin)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Dashboard,
    beforeEnter: (to, from, next) => {
      // ...
      if (store.state.admin==false ) next({ path: '/admin/login' })
    else next()

    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/terminalpos',
    name: 'Terminalpos',
    component: Terminalpos
  },
  {
    path: '/terminalpos/devices',
    name: 'Device',
    component: Device
  },
  {
    path: '/product/:id',
    name: 'Almond',
    component: Details
  },
  
  {
    path: '/cart',
    name: 'Cart',
    component: Cart
  },
  {
    path: '/products/EverythingBagel',
    name: 'Everything',
    component: Everything
  },
  {
    path: '/products/GlazedDoughnut',
    name: 'Glazed',
    component: Glazed
  },
  {
    path: '/products/MarshmallowDreamBar',
    name: 'Marshmallow',
    component: Marshmallow
  },
  {
    path: '/products/PlainBagel',
    name: 'Plain',
    component: Plain
  },
  {
    path: '/products/BananaNutLoaf',
    name: 'Banana',
    component: Banana
  },
  {
    path: '/products/BananaNutLoaf',
    name: 'Banana',
    component: Banana
  },
  {
    path: '/products/CinnamonRaisinBagel',
    name: 'Raisin',
    component: Raisin
  },
  {
    path: '/user/create',
    name: 'Raisin',
    component: Create
  },
  {
    path: '/admin/login',
    name: 'Admin',
    component: AdminLogin
  },
  {
    path: '/rewards',
    name: 'Rewards',
    component: Rewards
  },
  {
    path: '/checkout',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
